<template>
  <h3 class="text-center font-weight-bold">
    {{ title }}
  </h3>
</template>

<script>
  export default {
    props: {
      title: {
        default: 'Missing title',
        required: true,
        type: String
      }
    }
  };
</script>

<style lang="scss" scoped>
  @media (max-width: 360px) {
    h3 {
      font-size: 1.4rem;
    }
  }
</style>
